/**
 * IGNIERE §165 「Recommended あなたに合う一握り」を訪問者ごとに変える（2026-08-10・user 承認）
 *
 * ■ なぜ自前で作るか
 * Shopify が標準で出せるおすすめは 2 種類だけで（公式ドキュメントで確認 2026-08-10）、
 * どちらも「この商品を見ている人向け」＝**誰が見ても同じ**。
 *   related       … この商品に似た商品（Shopify が自動生成）
 *   complementary … あわせて買う商品（人が手で指定）
 * 「この人向け」は標準に無く、有料アプリ（Wiser・LimeSpot 等）が要る。
 * ただしアプリは**購入履歴が溜まってから効く**ので、開店直後は月額を払って何も出ない。
 * user 裁定（2026-08-10）＝**初日から効く自前版で始め、軌道に乗ったらアプリを検討する**。
 *
 * ■ 何を出すか（ブランドの思想と噛み合わせる）
 * 履歴のレコメンドは放っておくと「見たものに似たものをもっと」を出す装置になる。
 * それは user が掲げる提供価値（「赤い服が好きな人に、黄色が好きだったと気づかせる」）と逆。
 * そこで**見ていない隣**を出す：
 *   ①同じブランドの、**まだ見ていない種類**
 *   ②同じ種類の、**まだ見ていないブランド**
 * この 2 つを交互に混ぜて 4 点（＝「一握り」）。
 *
 * ■ 作りの要点
 * - 見出し・「すべて見る」・帯・余白は **Horizon 純正のまま**。中身の並びだけ差し替える
 *   （＝手がかりが無い時・失敗した時は、純正のカルーセルがそのまま残る＝壊れない）
 * - 商品データは `templates/collection.ig-feed.liquid`（自前の JSON 窓口）から取る。
 *   売り切れはサーバー側で落としているので、ここには在庫のあるものしか来ない
 * - Horizon のコアには一切触れていない（掟 §3 の経路①＝JS runtime）
 */
(function () {
  'use strict';

  var KEY = 'ig_recently_viewed_v1'; // 履歴の置き場（sections/igniere-pdp-checked.liquid が書く）
  var SHOW = 5;                      // 常に 5 枚作る。4 列の画面では CSS が 5 枚目を隠す
                                     // （画面幅を変えても穴が空かない・隣の棚と列数がそろう）
  var MIN_HISTORY = 1;               // 1 点でも見ていれば軸は立つ（＝ブランドと種類が分かる）。
                                     // 0 点＝初めての人にだけ純正の棚を出す

  function readHistory() {
    try {
      var h = JSON.parse(localStorage.getItem(KEY) || '[]');
      // §302-3：記録は最大 20 件に増えた（お気に入りの引き出しのため）。ここは前と同じ新しい 8 件だけで軸を決める（選び方を変えない）
      return Array.isArray(h) ? h.slice(0, 8) : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * 履歴から最も強い軸を 1 つ選ぶ。
   * **新しく見たものほど重く数える**（一番古い＝1 点、一番新しい＝件数ぶん）。
   * 昨日の気まぐれより、今さっき見ていたものを信じる。
   */
  function strongest(list, field) {
    var score = {};
    list.forEach(function (item, i) {
      var v = item && item[field];
      if (!v) return;
      score[v] = (score[v] || 0) + (list.length - i);
    });
    var best = null, bestScore = 0;
    Object.keys(score).forEach(function (k) {
      if (score[k] > bestScore) { bestScore = score[k]; best = k; }
    });
    return best;
  }

  function fetchFeed(param, value) {
    if (!value) return Promise.resolve([]);
    // param が 'view' の時は絞り込み無し＝全商品（在庫のあるものだけ返る）
    var url = param === 'view'
      ? '/collections/all?view=ig-feed'
      : '/collections/all?' + param + '=' + encodeURIComponent(value) + '&view=ig-feed';
    // ⚠ `Accept: application/json` を**付けてはいけない**（実測 2026-08-10）。
    //    付けると Shopify が別の応答を返し、中身が空で戻る（エラーにならないので気づきにくい）。
    //    この窓口は「JSON を吐く見た目テンプレート」であって JSON API ではない、という違い。
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.items) || []; })
      .catch(function () { return []; }); // 取れなくても棚は純正のまま＝買い物は止めない
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** 見た目はサイト共通のカード（.ig-card）と同一。PDP の棚・チェックドと同じ組み */
  function cardHtml(p) {
    // §270：1行目はブランド名。ブランドの無い商品（NO BRAND か空）だけ商品タイプ
    var label = p.vendor && String(p.vendor).toUpperCase() !== 'NO BRAND' ? p.vendor : p.type;
    return '<a class="ig-card" href="' + esc(p.url) + '" data-handle="' + esc(p.handle) + '">' + // §412 data-handle＝クイック追加の取り寄せ（igniere-card-row.js）
      (p.img
        ? '<span class="ig-card__im">' +
            '<img class="ig-card__img" src="' + esc(p.img) + '" alt="" width="400" height="500" loading="lazy" decoding="async">' +
            (p.img2 ? '<img class="ig-card__img2" src="' + esc(p.img2) + '" alt="" aria-hidden="true" loading="lazy" decoding="async">' : '') +
          '</span>'
        : '') +
      (label ? '<p class="ig-card-cat">' + esc(label) + '</p>' : '') +
      '<p class="ig-card__title">' + esc(p.title) + '</p>' +
      '<span class="ig-card__price">' + esc(p.price) + '</span>' +
      // 色見本は Liquid 側で純正と同じ部品から作った HTML をそのまま入れる
      // （店の中で生成したものなので、そのまま置いてよい）
      (p.chips || '') +
    '</a>';
  }

  /**
   * 候補を選ぶ。第 1 希望は「見ていない隣」。
   * それで 4 点に届かない時だけ、条件をゆるめて「見ていない商品」まで広げる
   * （棚が虫食いで出るより、埋まっている方がよい）。
   */
  function pick(sameBrand, sameType, seen) {
    var out = [], used = {};
    function take(list, i) {
      var p = list[i];
      if (!p || used[p.handle] || out.length >= SHOW) return;
      used[p.handle] = 1;
      out.push(p);
    }
    // ①同じブランドの見ていない種類 ②同じ種類の見ていないブランド を交互に。
    // このとき**すぐ上の「新作入荷」に出ている商品は避ける**（同じ面で同じ顔が二度出ない）。
    // 避けきれず 4 点に届かない時は、下の補いで避ける条件を落とす＝
    // 「重複を避けること」より「棚が埋まっていること」を優先する
    var inNew = handlesInNewArrival();
    var a = sameBrand.filter(function (p) { return !seen.handles[p.handle] && !seen.types[p.type] && !inNew[p.handle]; });
    var b = sameType.filter(function (p) { return !seen.handles[p.handle] && !seen.vendors[p.vendor] && !inNew[p.handle]; });
    for (var i = 0; i < 12 && out.length < SHOW; i++) { take(a, i); take(b, i); }
    if (out.length >= SHOW) return out;

    // 足りない分は「軸の中で、まだ見ていない商品」から補う
    var rest = sameBrand.concat(sameType).filter(function (p) { return !seen.handles[p.handle]; });
    for (var j = 0; j < rest.length && out.length < SHOW; j++) take(rest, j);
    return out;
  }

  /**
   * それでも 4 点に届かない時の最後の補い。
   * 取扱点数が少ないうちは、1 ブランド 1 種類から 4 点を作れないことが普通に起きる
   * （実測 2026-08-10＝ジャケットを 2 点見た後、条件に合うのは 3 点だけだった）。
   * ここで諦めて純正へ戻すと「履歴があるのに一生変わらない棚」になるので、
   * **まだ見ていない商品**から静かに埋める。並び順は前の候補を崩さない（後ろに足すだけ）。
   */
  function fillFromAll(out, seen) {
    var used = {};
    out.forEach(function (p) { used[p.handle] = 1; });
    var inNew = handlesInNewArrival();
    return fetchFeed('view', 'all').then(function (all) {
      // 2 周する。1 周目は**新作の棚に出ていないもの**だけ、2 周目で条件を落とす。
      // 「重複を避けること」より「棚が埋まっていること」が優先だが、避けられるなら避ける
      [true, false].forEach(function (avoidNew) {
        for (var i = 0; i < all.length && out.length < SHOW; i++) {
          var p = all[i];
          if (!p || used[p.handle] || seen.handles[p.handle]) continue;
          if (avoidNew && inNew[p.handle]) continue;
          used[p.handle] = 1;
          out.push(p);
        }
      });
      return out;
    });
  }

  /** 「新作入荷」の棚に今出ている商品を拾う（同じ商品を 2 つの棚に並べないため） */
  function handlesInNewArrival() {
    var map = {};
    document.querySelectorAll('[id$="__new_arrival"] a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').split('?')[0].match(/[/]products[/]([^/]+)$/);
      if (!m) return;
      // §280 自己点検（2026-10-07）：リンクの住所は日本語が %E3… に符号化されていて、棚の材料（ig-feed）の handle は
      // 日本語のまま＝そのままでは一致せず、新作の棚の商品を 1 つも除けていなかった（日本語の handle の商品が入った 10/1 から）。
      // 10/7 に「すべての商品」を新着順にしたため、初めての人の Recommended が NEW ARRIVAL と同じ顔ぶれになった。戻してから比べる
      var h = m[1];
      try { h = decodeURIComponent(h); } catch (e) {}
      map[h] = 1;
      map[m[1]] = 1;
    });
    return map;
  }

  /**
   * §165-2 初めての人（履歴が無い人）向け（user 指摘 2026-08-10）。
   *
   * ここを作る前は、履歴が無い人には**純正の棚がそのまま**出ていた。その純正の棚は
   * 「すべての商品」を名前のあいうえお順で並べる作りなので、**売り切れの商品が 1 番目**に出ていた
   * ＝**今回の発端そのものが、初めての人には直っていなかった**。
   * さらに、すぐ上の「新作入荷」と中身が大きく重なっていた（8 点中 5 点）。
   *
   * そこで履歴が無い人にも、**在庫があって、新作の棚に出ていない商品**を出す。
   * これで「売り切れが先頭」と「上の棚と同じ顔ぶれ」が同時に消える。
   */
  function forFirstVisit(host, section) {
    var inNew = handlesInNewArrival();
    return fetchFeed('view', 'all').then(function (all) {
      var out = [];
      for (var i = 0; i < all.length && out.length < SHOW; i++) {
        if (!inNew[all[i].handle]) out.push(all[i]);
      }
      if (out.length < SHOW) return;
      render(host, section, out);
    });
  }

  function render(host, section, list) {
    host.innerHTML = '<div class="ig-card-grid ig-foryou__grid">' +
      list.slice(0, SHOW).map(cardHtml).join('') + '</div>';
    section.setAttribute('data-ig-foryou', 'on');
  }

  /* この仕組みを当てる棚。
     ・`__recommended` ＝ トップの「Recommended あなたに合う一握り」
     ・`__also_like`  ＝ 独立したカートページの「YOU MAY ALSO LIKE」
       （カートページは今のところ導線が無く URL を直に叩かないと来ないが、
        中身は「すべての商品の先頭 4 点」＝売り切れも混ざる古い作りだった。
        放置すると URL を知る人だけ古い面を見ることになるので、同じ仕組みに揃える・
        user 裁定 2026-08-10） */
  var SHELVES = '[id$="__recommended"], [id$="__also_like"]';

  function run() {
    document.querySelectorAll(SHELVES).forEach(runOne);
  }

  function runOne(section) {
    if (!section || section.getAttribute('data-ig-foryou') === 'on') return;
    var host = section.querySelector('.resource-list');
    if (!host) return;

    var history = readHistory();
    var vendor = history.length ? strongest(history, 'vendor') : null;
    var type = history.length ? strongest(history, 'type') : null;

    // 履歴が無い人・軸が立たない人にも、在庫のあるものだけを出す（§165-2）
    if (history.length < MIN_HISTORY || (!vendor && !type)) {
      forFirstVisit(host, section);
      return;
    }

    var seen = { handles: {}, types: {}, vendors: {} };
    history.forEach(function (it) {
      if (it.handle) seen.handles[it.handle] = 1;
      if (it.type) seen.types[it.type] = 1;
      if (it.vendor) seen.vendors[it.vendor] = 1;
    });

    Promise.all([
      fetchFeed('filter.p.vendor', vendor),
      fetchFeed('filter.p.product_type', type)
    ]).then(function (res) {
      var chosen = pick(res[0], res[1], seen);
      var next = chosen.length >= SHOW ? Promise.resolve(chosen) : fillFromAll(chosen, seen);
      return next.then(function (list) {
        // 揃わない時は、初めての人と同じ「在庫あり・新作と重ならない」棚に落とす
        // （純正へ戻すと売り切れが先頭に出てしまうため）
        if (list.length < SHOW) return forFirstVisit(host, section);
        render(host, section, list);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
